export const PAYMENT_MODE = {
  ONLINE: "ONLINE",
  COD: "COD",
} as const

export type PaymentMode = (typeof PAYMENT_MODE)[keyof typeof PAYMENT_MODE]

export const DEFAULT_CHECKOUT_PAYMENT_MODE: PaymentMode = PAYMENT_MODE.ONLINE

export type PaymentModeContent = {
  label: string
  description: string
  checkoutCtaLabel: string
  confirmActionLabel: string
  confirmInfoText: string
}

export const PAYMENT_MODE_CONTENT: Record<PaymentMode, PaymentModeContent> = {
  [PAYMENT_MODE.ONLINE]: {
    label: "Pay Now",
    description: "Secure online payment",
    checkoutCtaLabel: "Continue to Secure Payment",
    confirmActionLabel: "Confirm & Continue",
    confirmInfoText: "Next step: enter payment details securely.",
  },
  [PAYMENT_MODE.COD]: {
    label: "Cash on Delivery",
    description: "Pay at delivery",
    checkoutCtaLabel: "Place COD Order",
    confirmActionLabel: "Confirm COD Order",
    confirmInfoText: "Pay with cash when your order arrives.",
  },
}

export const PAYMENT_MODE_OPTIONS: readonly PaymentMode[] = [PAYMENT_MODE.ONLINE, PAYMENT_MODE.COD]
